<input
  [type]="type"
  class="sat-input-control-primary-1"
  [formControl]="control"
  (keydown)="onkeyDownEvent($event)"
  (blur)="checkValid()"
  [attr.maxlength]="attributes?.maxlength"
  [attr.max]="attributes?.max"
  [attr.min]="attributes?.min"
  [placeholder]="placeholder"
  #searchFMInput
/>
@if (isError) {
  <div class="text-error">
    {{ errorMessage }}
  </div>
}
